"use strict";
import Account from "../../api/account";
import { History } from "react-router";
import { Link } from "react-router";
import * as popout from "./../popout";
export default React.createClass({
  mixins: [History],
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__header" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-header" }, this.invoiceTitle()), !Account.auditBillingEnabled() && /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-status" }, this.invoiceStatus(this.props.carrierInvoice)));
  },
  invoiceTitle: function() {
    if (Account.currentSettings().display_load_reference_as_title) {
      return null;
    }
    if (this.props.load.load.source_system === "hubtran") {
      return /* @__PURE__ */ React.createElement("div", null, "Editing Draft Load\xA0", /* @__PURE__ */ React.createElement("small", null, /* @__PURE__ */ React.createElement(Link, { to: this.assignLoadsUrl() }, "Go back and select a load")));
    }
    return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-header-text" }, "Load ", this.props.load.load.load_id);
  },
  billingRequirementsLink: function() {
    if (!Account.auditBillingEnabled() && this.useBillingReqsPopout()) {
      return /* @__PURE__ */ React.createElement("h3", { className: "load-detail__billing-requirements" }, /* @__PURE__ */ React.createElement("a", { onClick: () => popout.openOrFocusBillingReqsPopout() }, "View Billing Requirements"));
    }
  },
  invoiceStatus: function(invoice) {
    return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-status-text" }, "Status: ", invoice.status);
  },
  assignLoadsUrl() {
    return "/index-document-batches/" + this.props.batchId;
  },
  useBillingReqsPopout() {
    return Account.useBillingReqsPopout() && Account.hasRole("Broker");
  }
});
